__turbopack_context__.v({
  "heading-container": "WBa81W_heading-container",
  "product-item": "WBa81W_product-item",
  "products-list": "WBa81W_products-list",
  "related-products": "WBa81W_related-products",
  "title": "WBa81W_title",
});
